import RecordProcessPanel from "@viz-ui/components/RecordProcessPanel/RecordProcessPanel";
import ReactDirective from "acl-ui/angular/reactDirective.umd";
import ProcessPanel from "@viz-ui/components/ProcessPanel/ProcessPanel";
import ProcessPanelComponent from "./processPanel.component";
import ProcessPanelService from "./processPanel.service";

angular
  .module("acl.visualizer.processPanel", ["acl.common.config", "acl.visualizer.dataModel", "acl.visualizer.formatters"])
  .component("aclProcessPanel", ProcessPanelComponent)
  .directive("recordProcessPanel", ReactDirective.getFactory(RecordProcessPanel))
  .directive("reactProcessPanel", ReactDirective.getFactory(ProcessPanel))
  .service("ProcessPanelService", ProcessPanelService);
